export const PERIOD_START = 'redeemStart'
export const PERIOD_END = 'redeemEnd'
export const FIELD_DATE = 'data'
export const FIELD_TIME = 'hora'
